@if (activeNavigationItem.action == 'adapterType') {
<mvs-widget *ngIf="integrationAdapterTypeWidget" [widgetData]="integrationAdapterTypeWidget"></mvs-widget>
}

@if (activeNavigationItem.action == 'adapterTypeVariable') {
    <mvs-widget *ngIf="integrationAdapterTypeVariableWidget" [widgetData]="integrationAdapterTypeVariableWidget"></mvs-widget>
}
